import { useV2ListUserFiltersForAccountQuery, V2ServiceFilter } from "@generated";
import { UserSelectionsState } from "../types";

interface Filter {
  label: string;
  value: string;
  serviceType: string;
  filters: V2ServiceFilter;
}

const useListV1ServiceFiltersForAccount = (serviceType) => {
  let customError: string | null = null; // Declare customError

  const { data, error, isLoading, refetch, isFetching } =
    useV2ListUserFiltersForAccountQuery({
    });

  let filters: Filter[] = [];

  if (data?.data) {
    try {
      filters = data.data.map((filter, i) => {
        if (!filter.id) {
          throw new Error("Missing filter.id");
        }
        if (!filter.attributes) {
          throw new Error("Missing filter.attributes");
        }

        return {
          value: String(filter.id),
          label: filter.attributes.name || "",
          serviceType: filter.attributes?.["data-type"],
          filters: filter.attributes.filters as V2ServiceFilter,
        };
      });
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    filters,
    filtersLoading: isLoading,
    error: error ?? customError,
    refetch,
    filtersFetching: isFetching,
  };
};
export default useListV1ServiceFiltersForAccount;
